/* Reusable manual-donation details panel: bank transfer + mobile money.
   `donation` is the donation object from siteSettings or an event. */
import { Card, Icon } from "../ui/index.js";

function Row({ label, value }) {
  if (!value) return null;
  return (
    <div className="row row--between" style={{ padding: "8px 0", borderBottom: "1px solid var(--border)" }}>
      <span className="t-sm muted">{label}</span>
      <span className="t-sm" style={{ fontWeight: 600, textAlign: "right" }}>{value}</span>
    </div>
  );
}

export default function DonationDetails({ donation }) {
  if (!donation) return null;
  const hasBank = donation.bankName || donation.bankAccountNumber || donation.bankAccountName;
  const hasMomo = donation.momoNumber || donation.momoName;
  return (
    <div className="stack-lg">
      {hasBank && (
        <Card variant="elevated" style={{ padding: 24 }}>
          <div className="row" style={{ gap: 10, alignItems: "center", marginBottom: 8 }}>
            <div className="icon-circle"><Icon.Gift size={18} /></div>
            <h3 className="t-xl" style={{ margin: 0 }}>Bank transfer</h3>
          </div>
          <Row label="Bank" value={donation.bankName} />
          <Row label="Account name" value={donation.bankAccountName} />
          <Row label="Account number" value={donation.bankAccountNumber} />
          <Row label="Branch" value={donation.bankBranch} />
          <Row label="SWIFT" value={donation.swift} />
        </Card>
      )}

      {hasMomo && (
        <Card variant="elevated" style={{ padding: 24 }}>
          <div className="row" style={{ gap: 10, alignItems: "center", marginBottom: 8 }}>
            <div className="icon-circle"><Icon.Phone size={18} /></div>
            <h3 className="t-xl" style={{ margin: 0 }}>Mobile money</h3>
          </div>
          <Row label="Provider" value={donation.momoProvider} />
          <Row label="Number" value={donation.momoNumber} />
          <Row label="Name" value={donation.momoName} />
        </Card>
      )}

      {donation.notes && (
        <p className="t-sm muted" style={{ margin: 0, fontStyle: "italic" }}>{donation.notes}</p>
      )}
    </div>
  );
}
